import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'


class FormattedMessage extends PureComponent {

  static propTypes = {
    children: PropTypes.any,
    tag: PropTypes.string,
    en: PropTypes.string.isRequired,
    es: PropTypes.string,
    values: PropTypes.object,
    name: PropTypes.string, // deprecated - used for debugging missed messages
  }

  static contextTypes = {
    intlData: PropTypes.object,
  }

  render() {
    const { intlData: { intl, locale } } = this.context

    const {
      children, tag = 'span', tagId, en, es, values, name,
      _ref, defaultMessage, dataTestId, ...rest
    } = this.props

    const message = intl.formatMessage({ en, es }, values, locale)

    if (typeof children === 'function') {
      return children(message)
    }

    return React.createElement(tag, {
      'data-testid': dataTestId, // should be before ...rest bcs there are <FormattedMessage data-testid="smth" /> places
      ...rest,
      id: tagId,
      ref: _ref,
    }, message)
  }
}


export default FormattedMessage
